import React, { Component } from 'react'
import orderBy from 'lodash/orderBy'
import PanelCategories from '../PanelCategories'
import PanelPromotions from '../PanelPromotions'
import PanelFormats from '../PanelFormats'

class Panels extends Component {
  constructor(props){
    super(props)

    this.state = {
      select: props.defaultPanel || 'categories' 
    }
  }

  onSwitch(panel){
    const { select } = this.state

    this.setState({
      select: panel || (select == 'categories' ? 'promotions' : 'categories')
    })
  }

  render () {
    switch(this.state.select) {
      case 'formats':
        return (
          <PanelFormats
            {...this.props}
            data={orderBy(this.props.data.formats, 'es_competition', 'desc')}
          />
        )
        break;
      case 'promotions':
        return (
          <PanelPromotions 
            {...this.props}
            data={orderBy(this.props.data.promotions, 'es_competition', 'desc')}
          />
        )
        break;
      case 'categories': 
      default:
        return (
          <PanelCategories 
            {...this.props}
            data={orderBy(this.props.data.categories, 'es_competition', 'desc')}
          />
        )
        break;
    }
  }
}

export default Panels


// WEBPACK FOOTER //
// ./src/components/SocialIntelligence/CommunicationStrategy/components/Panels/index.js